export const overviewBundle = {
  title: {
    ko: "주간 정보",
    en: "Weekly Summary",
    es: "Resumen semanal"
  },
  labels: [
    {
      key: "total_customers",
      label: {
        ko: "전체 수용가 수",
        en: "Total Customers",
        es: "Total de clientes"
      },
      unit: { ko: "가구", en: "HH", es: "Hogares" }
    },
    {
      key: "total_leak_customers",
      label: {
        ko: "누수 수용가 수",
        en: "Customers with Leaks",
        es: "Clientes con fugas"
      },
      unit: { ko: "가구", en: "HH", es: "Hogares" }
    },
    {
      key: "total_usage",
      label: {
        ko: "총 사용량",
        en: "Total Usage",
        es: "Consumo total"
      },
      unit: { ko: "m³", en: "m³", es: "m³" }
    },
    {
      key: "total_leak_amount",
      label: {
        ko: "총 누수량",
        en: "Total Leakage Volume",
        es: "Volumen total de fugas"
      },
      unit: { ko: "m³", en: "m³", es: "m³" }
    }
  ]
}
